import BaseHelper from './moment-base';
import moment from 'moment';

export default class MomentDiff extends BaseHelper {
  compute([dateA, dateB], { precision = 'milliseconds', float = false } = {}) {
    super.compute(...arguments);
    if (!dateA || !dateB) {
      return null; // Return null if either date is missing
    }
    return moment(dateB).diff(moment(dateA), precision, float);
  }
}
